import React from 'react';
import styled from 'styled-components';
import Icon from '../../app/common/components/Icon';
import ICONS from '../../app/common/constants/icons';
import { TranslationHelpers } from '../../i18n/translationHelpers';

const WarningBanner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    background-color: #fef0dd;
    border-radius: 8px;
    padding: 12px;
    color: #a35e04;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 40px;
`;

const WarningIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
`;

const SessionRevocationWarning: React.FC = () => {
    return (
        <WarningBanner>
            <WarningIconWrapper>
                <Icon icon={ICONS.INFO_FILLED} size="16" viewBoxMax="16" fill="#a35e04" />
            </WarningIconWrapper>
            {TranslationHelpers.getFormattedMessage(
                'notifications.account.password.update.session_revocation_warning',
            )}
        </WarningBanner>
    );
};

export default SessionRevocationWarning;
